import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import * as _ from "lodash";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import { Alert } from "src/app/shared/class/Alert";
import {
  ColumnField,
  PlnTableComponent,
  TableAction,
  TablePagination,
} from "src/app/shared/components/pln-table/pln-table.component";
import { globalConst } from "src/app/shared/helpers/constants";
import { Helper } from "src/app/shared/helpers/helper";
import { ResponseData } from "src/app/shared/http/api";
import { Agent } from "src/app/shared/models/agent.model";
import { Company } from "src/app/shared/models/company";
import { Regional } from "src/app/shared/models/regional";
import { ServiceLocal } from "src/app/shared/models/service-request.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { ServiceRequestService } from "../service-request.service";
import { UpdateDatabaseService } from "./../../update-database/update-database.service";

@Component({
  selector: "app-service-request",
  templateUrl: "./service-request.component.html",
  styleUrls: ["./service-request.component.scss"],
})
export class ServiceRequestComponent implements OnInit {
  goback = "";
  expandedFilterPanel = true;
  filtersForm: FormGroup;
  subscription = new Subscription();

  companyOptions: Company[] = [];
  regionalOptions: Regional[] = [];
  serviceLocalOptions: ServiceLocal[] = [];
  agents: Agent[] = [];
  lastUpdateTable = "";

  responseData: ResponseData;
  displayedColumns: ColumnField[] = [
    {
      value: "id",
      showValue: "ID",
      orderBy: false,
      size: 10,
    },
    {
      value: "situation",
      showValue: "Situação",
      orderBy: true,
      size: 10,
      type: PlnTableComponent.fieldValue().requestStatus,
    },
    {
      value: "date",
      showValue: "Data",
      orderBy: true,
      size: 8,
      type: PlnTableComponent.fieldValue().date,
    },
    {
      value: "hour",
      showValue: "Hora",
      orderBy: true,
      size: 7,
    },
    {
      value: "companyDescription",
      showValue: "Cliente",
      orderBy: true,
      size: 10,
    },
    {
      value: "regionalDescription",
      showValue: "Regional",
      orderBy: true,
      size: 15,
    },
    {
      value: "serviceLocalDescription",
      showValue: "Local",
      orderBy: true,
      size: 25,
    },
    {
      value: "agentName",
      showValue: "Técnico",
      orderBy: true,
      size: 10,
    },
  ];
  tablePagination: TablePagination;
  tableActions: TableAction[] = [
    {
      action: "edit",
      icon: "edit",
      routerLink: "/serviceRequest/details",
      tooltip: "Editar",
    },
  ];
  constructor(
    private spinner: NgxSpinnerService,
    private serviceRequestService: ServiceRequestService,
    private authService: AuthService,
    private updateDatabaseService: UpdateDatabaseService,
    private router: Router
  ) {}

  async ngOnInit() {
    this.spinner.show();
    this.filtersForm = new FormGroup({
      id: new FormControl(null as string),
      status: new FormControl("" as string),
      company: new FormControl(null as number),
      regional: new FormControl(null as number),
      serviceLocal: new FormControl(null as number),
      agent: new FormControl(null as number),
    });
    await this.loadCompanyOptions();
    await this.loadRegionalOptions();
    await this.loadServiceLocalOptions();
    await this.loadAgents();
    this.spinner.hide();

    this.listenChangeCompany();
    this.listenChangeRegional();
    this.listenChangeServiceLocal();
    this.filter();
  }

  private listenChangeCompany() {
    const control = this.filtersForm.controls.company;
    control.valueChanges.subscribe(async () => {
      if (!control.errors) {
        try {
          if (control.value === "") {
            await this.loadRegionalOptions();
            await this.loadServiceLocalOptions();
          } else {
            this.spinner.show();
            this.regionalOptions = [];
            this.filtersForm.controls.regional.setValue(null);
            await this.loadRegionalOptions();
            this.regionalOptions = this.regionalOptions.filter(
              (obj) => obj.companyAlternativeIdentifier === control.value
            );

            this.serviceLocalOptions = [];
            await this.loadServiceLocalOptions();
            this.loadAllServiceLocalsByCompany();

            this.filtersForm.controls.regional.setValue("");
            this.filtersForm.controls.serviceLocal.setValue("");

            this.spinner.hide();
          }
        } catch (error) {
          this.spinner.hide();
          Helper.handleError(error);
        }
      }
    });
  }

  private listenChangeRegional() {
    const control = this.filtersForm.controls.regional;
    control.valueChanges.subscribe(async () => {
      if (!control.errors) {
        try {
          this.spinner.show();
          await this.loadServiceLocalOptions();
          if (control.value === "") {
            this.loadAllServiceLocalsByCompany();
          } else {
            this.serviceLocalOptions = this.serviceLocalOptions.filter(
              (obj) => obj.regionalId === control.value
            );
            if (!this.serviceLocalOptions.length) {
              Alert.warning(Alert.getMessage().errors.serviceLocal.emptySearch);
            }
          }
          this.spinner.hide();
        } catch (error) {
          this.spinner.hide();
          Helper.handleError(error);
        }
      }
    });
  }

  private listenChangeServiceLocal() {
    const control = this.filtersForm.controls.serviceLocal;
    control.valueChanges.subscribe(async () => {
      if (!control.errors) {
        if (!_.isNull(control.value) && control.value !== "") {
          this.filtersForm.controls.regional.setValue(
            this.serviceLocalOptions.find((obj) => obj.id === control.value)
              .regionalId
          );
        }
      }
    });
  }

  private loadAllServiceLocalsByCompany() {
    const auxServiceLocal = [];
    this.filtersForm.controls.serviceLocal.setValue(null);
    this.regionalOptions.map((regional) => {
      // tslint:disable-next-line: max-line-length
      this.serviceLocalOptions
        .filter((obj) => obj.regionalId === regional.id)
        .map((serviceLocal) => auxServiceLocal.push(serviceLocal));
    });
    this.serviceLocalOptions = auxServiceLocal;
    this.filtersForm.controls.serviceLocal.setValue("");
    if (!this.serviceLocalOptions.length) {
      Alert.warning(Alert.getMessage().errors.serviceLocal.emptySearch);
    }
  }

  async loadCompanyOptions() {
    try {
      const data: any = await this.serviceRequestService.getCompanies();
      this.companyOptions =
        this.authService.getUserLogged().type ===
        globalConst.defaults.user.admin
          ? data.status === undefined
            ? data
            : []
          : this.authService.getUserLogged().companiesAssociate;

      if (!this.companyOptions.length) {
        Alert.warning(Alert.getMessage().errors.company.emptySearch);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async loadRegionalOptions() {
    try {
      const data: any = await this.serviceRequestService.getRegionals();
      this.regionalOptions =
        this.authService.getUserLogged().type ===
        globalConst.defaults.user.admin
          ? data.status === undefined
            ? data
            : []
          : this.authService.getUserLogged().regionalsAssociate;
    } catch (error) {
      console.error(error);
    }
  }

  async loadServiceLocalOptions() {
    try {
      const data: any = await this.serviceRequestService.getServiceLocals();
      this.serviceLocalOptions =
        this.authService.getUserLogged().type ===
        globalConst.defaults.user.admin
          ? data.status === undefined
            ? data
            : []
          : this.authService.getUserLogged().serviceLocalsAssociate;
    } catch (error) {
      console.error(error);
    }
  }

  async loadAgents() {
    try {
      const data: any = await this.serviceRequestService.getAgents();
      this.agents =
        data.status === undefined ? Agent.orderAgentByName(data) : [];
    } catch (error) {
      console.error(error);
    }
  }

  async resetFilterForm() {
    this.filtersForm = new FormGroup({
      id: new FormControl(null as string),
      status: new FormControl({} as string),
      company: new FormControl(null as number),
      regional: new FormControl(null as number),
      serviceLocal: new FormControl(null as number),
      agent: new FormControl(null as number),
    });

    await this.loadCompanyOptions();
    await this.loadRegionalOptions();
    await this.loadServiceLocalOptions();
    await this.loadAgents();
  }

  resetFilters() {
    this.filtersForm.reset();
    this.responseData = null;
    this.search();
  }

  handleFilter(pagination?: TablePagination) {
    this.tablePagination = pagination;
    this.filter();
  }

  handleAction(event: TableAction) {
    switch (event.action) {
      case "edit":
        this.router.navigate([event.routerLink], {
          queryParams: event.queryParams,
        });
        break;
      default:
        break;
    }
  }

  search() {
    if (this.tablePagination) this.tablePagination.page = 1;
    this.filter();
  }

  filter() {
    this.spinner.show("osSpinner");

    this.subscription.add(
      this.serviceRequestService
        .listSchedules({ ...this.filtersForm.value, ...this.tablePagination })
        .subscribe(
          (res) => {
            this.spinner.hide("osSpinner");
            this.responseData = res;
          },
          (err) => {
            this.spinner.hide("osSpinner");
            this.responseData = null;
            Alert.error(Alert.getMessage().errors.emptySearch);
          }
        )
    );
  }
}
